




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { bus } from '@/main'
const onClickaway = require('vue-clickaway');

@Component({
	directives: {
		onClickaway: onClickaway.directive
	}
})
export default class StatementTitle extends Vue {
	@Prop({ required: true }) title!: string | {[key: number]: string | {text: string, information: string}}

	tooltipOpen: number = -1

	@Watch('tooltipOpen')
	onTooltipOpenChange(): void {
		if (this.tooltipOpen !== -1) {
			_paq.push(['trackEvent', 'userEvent', 'viewWordDefinition'])
		}
	}

	created() {
		bus.$on('changeDirection', () => {
			this.tooltipOpen = -1
		})

		document.addEventListener('keydown', e => {
			if (e.keyCode === 27) {
				this.tooltipOpen = -1
			}
		})
	}
}
